/**
 * Created by Alican Köker on 2018-12-19.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {TimelineLite} from "gsap";
import {EdisonGameModuleConfig} from "../../../EdisonGameModuleConfig";
import {EdisonSoundConfig} from "../../../EdisonSoundConfig";
import {EdisonGameMode} from "../../../gameMode/EdisonGameMode";
import {EdisonParsedInitData} from "../../../server/data/EdisonParsedInitData";
import {EdisonIndividualWPView} from "../../../winpresentation/individual/EdisonIndividualWPView";

export class EdisonFreespinIntroController extends FreespinIntroController {

    private _restoreMode:boolean = false;

    constructor(config:IScreenConfig, tweakEnabled?:boolean) {
        super(config, tweakEnabled);

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    protected onInitDataParsed(data:EdisonParsedInitData):void {
        this._restoreMode = data.isRestoreState && data.nextMode === EdisonGameMode.FREESPIN;
    }

    protected parseFeatureGameData(data:ParsedServerData):void {

    }

    protected doTransitions():void {
        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            EdisonGameModuleConfig.background.currentMode = EdisonGameMode.FREESPIN;
            EventHandler.dispatchEvent(new GameEvent(EdisonIndividualWPView.SET_MODE, EdisonGameMode.FREESPIN));
        }, 2);
    }

    public close(closeCallback?:() => void):void {
        super.close();
        SlotGame.sound.playAmbience(EdisonSoundConfig.instance.FREESPIN_AMBIANCE);
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.fadeAmbience(1, 5000);

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
    }
}